module.exports = __webpack_public_path__ + "static/media/icon_down.84cca33e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_down.svg
// module id = 159
// module chunks = 0